import {
  CreateOrganizationGroupDto,
  ListResponse,
  OrganizationGroupDto,
  UpdateOrganizationGroupDto,
} from "@dialogics/shared/dto/types"
import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"

export const organizationGroupApi = createApi({
  reducerPath: "organizationGroupApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/organization-group" }),
  tagTypes: ["OrganizationGroup"],
  endpoints: builder => ({
    getOrganizationGroups: builder.query<ListResponse<OrganizationGroupDto>, { organizationId?: number }>({
      query: params => ({
        url: `/list`,
        body: params,
        method: "POST",
      }),
      providesTags: result =>
        result
          ? [
              ...result.results.map(({ id }) => ({
                type: "OrganizationGroup" as const,
                id,
              })),
              { type: "OrganizationGroup", id: "LIST" },
            ]
          : [{ type: "OrganizationGroup", id: "LIST" }],
    }),
    createOrganizationGroup: builder.mutation<OrganizationGroupDto, CreateOrganizationGroupDto>({
      query: data => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "OrganizationGroup", id: "LIST" }],
    }),
    updateOrganizationGroup: builder.mutation<OrganizationGroupDto, { id: number } & UpdateOrganizationGroupDto>({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "OrganizationGroup", id }],
    }),
    getOrganizationGroup: builder.query<OrganizationGroupDto, number>({
      query: id => `/${id}`,
      providesTags: (_result, _error, id) => [{ type: "OrganizationGroup", id }],
    }),
  }),
})

export const {
  useGetOrganizationGroupsQuery,
  useCreateOrganizationGroupMutation,
  useUpdateOrganizationGroupMutation,
  useGetOrganizationGroupQuery,
} = organizationGroupApi
